<template>
  <div class="IndexMenulist">
    <div class="card">
      <div class="top">
        <div class="card-item" v-for="(item, index) in typeJsonList" :key="index">
          <p class="name one">{{item.name}} <i class="el-icon-arrow-right"></i></p>
          
          <div class="href one">
            <template v-for="(type, tindex) in item.list">
              <span @click="goto(item.code, type.code)" :key="tindex" v-if="tindex < 4">{{type.name}}</span>
            </template>
            <!-- <span>证券事务代表</span> -->
            <!-- <span>董秘助理</span> -->
            <!-- <span>证代助理</span> -->
          </div>

          <div class="silder-card animated fadeInDown">
            <p class="name">{{item.name}}</p>
            <div class="href">
              <template v-for="(type, tindex) in item.list">
                <span @click="goto(item.code, type.code)" :key="tindex">{{type.name}}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <p @click="goto()">全部分类</p>
      </div>
    </div>
  </div>
  <!-- end 菜单列表 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import "animate.css/animate.min.css"
import typeJson from '../../components/type.json' // 菜单类别
export default {
  name: 'IndexMenulist',
  data () {
    return {
      typeJsonList: typeJson
    }
  },
  mounted () {
  },
  methods: {
      goto(jobtypecode01, jobtypecode02) {  // 行业code 一级 行业code 二级
        this.$router.push({
          name: "TalentSearch",
          query: {jobtypecode01: jobtypecode01, jobtypecode02: jobtypecode02}
        })
      },
       ...mapActions([
            'setLoading'
        ])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
        'user'  
    ])
  },
  components: {
      
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.IndexMenulist {
  float: left;
  position: relative;
  width: 390px;
  height: 352px;

  .card {
    position: absolute;
    width: 390px;
    height: 352px;
    box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -webkit-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -moz-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -ms-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -o-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    .card-item {
      position: relative;
      padding: 16px 12px;
      box-sizing: border-box;
      height: 78px;
    }
    .card-item:hover {
      background: #2E7FFF;
      p.one.name,
      p.one.name i,
      .one.href span,
      .one.href p {
        color: #fff;
      }
    }
    .top {
      box-sizing: border-box;
      p.name {
        font-size: 15px;
        font-weight: bold;
        i {
          float: right;
          color: #999;
        }
      }
      .href {
        margin-top: 12px;
        overflow: hidden;

        span {
          margin-right: 20px;
          margin-bottom: 13px;
          float: left;
          cursor: pointer;
          color: #666;
          font-size: 14px;

          &:hover {
            text-decoration: underline;
            color: #2E7FFF;
          }
        }
      }
    }
    .bottom {
      padding: 0 14px;
      box-sizing: border-box;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #2E7FFF;
      cursor: pointer;
      border-top: dashed 1px #E5E5E5;
    }
  }
  .card-item:hover {
    .silder-card {
      display: block;
    }
  }
  .silder-card {
    position: absolute;
    display: none;
    left: 390px;
    z-index: 2;
    top: 0;
    padding: 20px;
    width: 390px;
    box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -ms-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -webkit-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -o-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    -moz-box-shadow:0px 2px 11px 0px rgba(132,132,132,0.5);
    box-sizing: border-box;
    background: #fff;

    p.name {
      font-size: 15px;
      font-weight: bold;
    }
    span {
      display: inline-block;
      margin-top: 12px;
      margin-right: 20px;
      color: #666666;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        color: #2E7FFF;
      }
    }
  }
}
</style>